import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=f39450c2&scoped=true&"
var script = {}
import style0 from "./Author.vue?vue&type=style&index=0&id=f39450c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39450c2",
  null
  
)

export default component.exports